import React from 'react';

import { useLocation } from 'react-router-dom';
import { Link as ReactRouterLink } from 'react-router-dom';

import Tab, { TabGroup } from '@amzn/meridian/tab';
import { AdminConfigPaths } from 'src/store/adminConfigPageSlice/common/constants';

// **** Components **** //

/**
 * Toggle the Task/TaskGroup Tables
 */
const TaskConfigurationTabs = () => {
  const location = useLocation();
  const { TASKS, TASK_GROUPS, NON_PHYSICAL_TASKS } = AdminConfigPaths.Task;

  return (
    <TabGroup value={location.pathname.split('/').pop()} onChange={() => {}}>
      <ReactRouterLink to={TASKS}>
        <Tab value={TASKS} id="tab-tasks">
          Physical Tasks
        </Tab>
      </ReactRouterLink>
      <ReactRouterLink to={TASK_GROUPS}>
        <Tab value={TASK_GROUPS} id="tab-taskGroups">
          Physical Task Groups
        </Tab>
      </ReactRouterLink>
      <ReactRouterLink to={NON_PHYSICAL_TASKS}>
        <Tab value={NON_PHYSICAL_TASKS} id="tab-nonPhysicalTasks">
          Non-Physical Tasks
        </Tab>
      </ReactRouterLink>
    </TabGroup>
  );
};

export default TaskConfigurationTabs;
